<script setup lang="ts" generic="T">
import { defineOptions, defineModel } from '#imports'

interface Props {
  id: string
  name: string
  value?: T
  disabled?: boolean
  isBlock?: boolean
  class?: any
  isSelectionOverflow?: boolean
  reverse?: boolean
}

const modelValue = defineModel<boolean | T[]>()

const props = withDefaults(defineProps<Props>(), {
  value: undefined,
  disabled: false,
  isBlock: false,
  isSelectionOverflow: false,
  class: undefined,
  reverse: false,
})

defineOptions({ inheritAttrs: false })
</script>

<template>
  <label
    :class="[props.class, props.isBlock ? 'flex' : 'inline-flex', props.disabled ? 'cursor-not-allowed' : 'hover:cursor-pointer', { 'flex-row-reverse': reverse }]"
    class="gap-2"
  >
    <input
      :id="props.id"
      v-model="modelValue"
      type="checkbox"
      :value="props.value"
      v-bind="$attrs"
      :disabled="props.disabled"
      class="rounded-xs bg-checked-pattern-white focus-visible:ring-peacock-300 disabled:checked:bg-checked-pattern-gray h-6 w-6 shrink-0 appearance-none border-2 border-gray-300 bg-[length:70%] bg-center bg-no-repeat outline-none transition-colors checked:border-black checked:bg-black hover:cursor-pointer focus-visible:ring-[3px] focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:!border-gray-200 disabled:!bg-gray-100 disabled:bg-none"
    >
    <span
      v-if="$slots.default"
      :class="{ 'text-gray-400': disabled }"
    ><slot /></span>
    <span
      v-if="isSelectionOverflow"
      class="absolute inset-0"
      aria-hidden="true"
    />
  </label>
</template>
